<app-easy-collect *ngIf="english"></app-easy-collect>
<app-easy-collect-hindi *ngIf="hindi"></app-easy-collect-hindi>